const routes = [
    {
        path: "/prep/schedules",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "prepschedule_index"
        }
    }
];

export default routes;
